<script>
    import { redirect, params } from '@sveltech/routify'
    import { authStore, Authenticator } from 'totalinvoice-frontend-core'
    import E503 from '../_503.svelte'

    if ($authStore.authenticated) {
        // user is logged in -> redirect to page
        const dest = $params['dest'];
        $redirect(dest ? dest : '/')
    } else {
        // user is not logged in -> show keycloak login page
        Authenticator.login()
    }
</script>

{#if $authStore.initialized}
    <slot />
{:else}
    <E503 />
{/if}
